import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { CrossSellEmailRenderer } from "./email";
import type { CrossSellBlockProps } from "./types";

export function CrossSellWebRenderer(props: CrossSellBlockProps) {
  const recommendations = (props.parcel as any)?.crossSellRecommendations;
  if (!recommendations?.length) return null;

  return (
    <EmailComponentWrapper shop={props.shop}>
      <CrossSellEmailRenderer {...props} />
    </EmailComponentWrapper>
  );
}
